import React, {Component, PropTypes} from 'react';
import {findDOMNode} from 'react-dom';
import {DragSource, DropTarget} from 'react-dnd';
const ItemTypes = {PRODUCT_IMAGE: 'productImage'};
import {FormControl} from 'react-bootstrap';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import { formatImageForBucket } from "../../util/Utils"
var _ = require('lodash');
const style = {
    border: '2px dashed gray',
    borderRadius:5,
    padding: '0.5rem 1rem',
    marginBottom: '.5rem',
    backgroundColor: 'white',
    cursor: 'move',
};
const productImageSource = {
    beginDrag(props) {
        return {
            id: props.image._id,
            index: props.index,
            originalIndex: props.index /* keep originalIndex, as item index is changed in setState before dropping*/
        };
    },
    endDrag(props, monitor) {
        if (!monitor.didDrop()) {
            // You can check whether the drop was successful
            // or if the drag ended but nobody handled the drop
            return;
        }

        let dropResult = monitor.getDropResult();

        /* dropResult is the dropped item */
        if (dropResult) {
            if (dropResult.originalIndex == dropResult.index) { /* it is dropped to the original place */
                return;
            }else{
                  //If there is a function on drop it will execute it
            if(props.onDrop) {
                try {
                    props.onDrop(dropResult, monitor);
                } catch (error) {
                    console.log(error)
                    console.log("Error on drop ProductImage file.")
                }
            }
            }
        } else {
            return;
        }
        props.reorderImages();
    },
};

const productImageTarget = {
    hover(props, monitor, component) {
        const dragIndex = monitor.getItem().index;
        const hoverIndex = props.index;
        // Don't replace items with themselves
        if (dragIndex === hoverIndex) {
            return;
        }

        // Determine rectangle on screen
        const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

        // Get vertical middle
        const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

        // Determine mouse position
        const clientOffset = monitor.getClientOffset();

        // Get pixels to the top
        const hoverClientY = clientOffset.y - hoverBoundingRect.top;

        // Only perform the move when the mouse has crossed half of the items height
        // When dragging downwards, only move when the cursor is below 50%
        // When dragging upwards, only move when the cursor is above 50%


        /* Remove this code because it was bugging the drag and drop
        // Dragging downwards
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
            return;
        }

        // // Dragging upwards
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
            return;
        }
        */

        // Time to actually perform the action
        props.moveImage(dragIndex, hoverIndex);

        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        // to avoid expensive index searches.
        monitor.getItem().index = hoverIndex;
    },
    drop(props, monitor, component) {
        return monitor.getItem();
    }
};

@DropTarget(ItemTypes.PRODUCT_IMAGE, productImageTarget, connect => ({
    connectDropTarget: connect.dropTarget(),
}))
@DragSource(ItemTypes.PRODUCT_IMAGE, productImageSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
}))
export default class ProductImage extends Component {
    static propTypes = {
        connectDragSource: PropTypes.func.isRequired,
        connectDropTarget: PropTypes.func.isRequired,
        index: PropTypes.number.isRequired,
        isDragging: PropTypes.bool.isRequired,
        image: PropTypes.object.isRequired,
       moveImage: PropTypes.func.isRequired,
    };

    render() {
         const {text, isDragging, connectDragSource, connectDropTarget} = this.props;
        const opacity = isDragging ? 0 : 1;

        return connectDragSource(connectDropTarget(
            <div key={this.props.image._id} style={{...style, opacity}} onClick={()=>{
                if(this.props.onImageSelect){
                this.props.onImageSelect(this.props.image)
            }
            }}
              className={classNames('image-item-wrapper', {'--selected':_.get(this.props,'selectedImage._id') == this.props.image._id})}       >
                <div className="image-wrapper">
                    <div onClick={() => this.props.deleteImage({URL:this.props.image.URL,'_id': this.props.image._id})}
                         className="delete-image"></div>
                    {this.props.saveImage &&
                    <div onClick={() => this.props.saveImage({
                            '_id': this.props.image._id,
                            'Caption': ReactDOM.findDOMNode(this.refs[this.props.image._id + '_Caption']).value
                        }
                    )
                    }
                         className="save-image"></div>
                    }
                    <img  src={formatImageForBucket(this.props.image.URL)}/>
                </div>
                {this.props.displayCustomContent &&this.props.displayCustomContent(this.props.image)}
                {this.props.saveImage &&
                <FormControl className="image-caption top10" type="text"
                             defaultValue={this.props.image.Caption} ref={this.props.image._id + '_Caption'}
                             placeholder="Caption"/>
                }
            </div>
        ));
    }
}
